var ArticlesEditData = React.createContext({});
export var ArticlesEditDataProvider = ArticlesEditData.Provider;
export var ArticlesEditDataConsumer = ArticlesEditData.Consumer;
export default ArticlesEditData;